import { Combobox, ComboboxOption } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { DetectedEntity, EntityType } from "../../types";
import { useChatContext } from "../../ChatProvider";
import { updateEntityType } from "../../store/chatSlice";

interface EntityItemProps {
  entity: DetectedEntity;
}

const entityTypeOptions: ComboboxOption[] = Object.values(EntityType).map(
  (type) => ({
    value: type,
    label: type.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase()),
  }),
);

export const EntityItem: React.FC<EntityItemProps> = ({ entity }) => {
  const { dispatch, currentSessionId } = useChatContext();
  const isUnknown = entity.selected_type === EntityType.UNKNOWN;

  const handleTypeChange = (newType: string) => {
    if (currentSessionId) {
      dispatch(
        updateEntityType({
          sessionId: currentSessionId,
          entityName: entity.name,
          newType: newType as EntityType,
        }),
      );
    }
  };

  return (
    <Stack
      direction="row"
      align="center"
      className={`al-px-3 al-py-1 al-rounded-md al-gap-2 al-whitespace-nowrap ${
        isUnknown
          ? "al-bg-red-50 al-border al-border-red-200"
          : "al-bg-purple-50"
      }`}
      role="listitem"
    >
      <span className="al-text-sm al-font-medium">{entity.name}</span>
      <span className="al-text-xs al-text-gray-600">is</span>

      <div className="al-flex-shrink-0 al-relative">
        <Combobox
          options={entityTypeOptions}
          value={entity.selected_type}
          onChange={handleTypeChange}
          placeholder="Select type..."
          buttonProps={{
            variant: "outline",
            size: "sm",
            className: `al-h-7 al-text-xs al-px-2 ${
              isUnknown ? "al-border-red-300 al-text-red-700 al-bg-red-50" : ""
            }`,
          }}
        />
        {isUnknown && (
          <span className="al-absolute al--top-1 al--right-1 al-text-red-500 al-text-xs">
            *
          </span>
        )}
      </div>
    </Stack>
  );
};
